module.exports = __webpack_public_path__ + "static/media/2_The inner voice_JP.1531ca63.txt";